import React, { useState, useRef } from "react";

import {
    Grid,
    Dialog,
    DialogTitle,
    Divider,
    Typography,
    StepLabel,
    Step,
    Stepper,
    makeStyles,
    DialogContent
} from '@material-ui/core';
import { ValidatorForm } from "react-material-ui-form-validator";

import { ButtonGeneric } from "../atoms/Buttons";
import { Fragment } from "react";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        margin: "-1em"
    },
}));


export const GenericModal = ({ open, title, children, handleClose, closeModal, handleSubmit, handleButton, textButton = "Guardar", gridStyle, maxWidth = "md", fullWidthButtons = false, disabledButton = false }) => {
    return (
        <Dialog
            maxWidth={maxWidth}
            fullWidth={true}
            open={open}
            onClose={closeModal}
        >
            <DialogTitle style={{ display: "flex", justifyContent: "center" }}>
                <Typography variant="button" style={{ fontSize: "1em" }}>
                    {title}
                </Typography>
            </DialogTitle>
            <Divider />
            {handleSubmit ? (
                <ValidatorForm onSubmit={handleSubmit}>
                    <Grid container>
                        <Grid item xs={12} style={{ margin: "1em", ...gridStyle }}>
                            {children}
                        </Grid>
                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "0.5em", margin: "1em" }}>
                            {!closeModal && handleClose && (
                                <ButtonGeneric
                                    type="button"
                                    text="Cerrar"
                                    fullWidth={fullWidthButtons}
                                    color="secondary"
                                    onClick={handleClose}
                                />
                            )}
                            {handleSubmit && (
                                <ButtonGeneric
                                    type="submit"
                                    fullWidth={fullWidthButtons}
                                    text={textButton}
                                />
                            )}
                            {handleButton && (
                                <ButtonGeneric
                                    type="button"
                                    fullWidth={fullWidthButtons}
                                    text={textButton}
                                    onClick={handleButton}
                                    disabled={disabledButton}
                                />
                            )}
                        </Grid>
                    </Grid>
                </ValidatorForm>
            ) : (
                <Grid container>
                    <Grid item xs={12} style={{ margin: "1em", ...gridStyle }}>
                        {children}
                    </Grid>
                    {
                        (!closeModal || handleSubmit || handleButton) &&
                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "0.5em", margin: "1em" }}>
                            {!closeModal && (
                                <ButtonGeneric
                                    type="button"
                                    text="Cerrar"
                                    color="secondary"
                                    fullWidth={fullWidthButtons}
                                    onClick={handleClose}
                                />
                            )}
                            {handleSubmit && (
                                <ButtonGeneric
                                    type="submit"
                                    fullWidth={fullWidthButtons}
                                    text={textButton}
                                />
                            )}
                            {handleButton && (
                                <ButtonGeneric
                                    type="button"
                                    text={textButton}
                                    fullWidth={fullWidthButtons}
                                    onClick={handleButton}
                                    disabled={disabledButton}
                                />
                            )}
                        </Grid>
                    }
                </Grid>
            )}
        </Dialog>
    );
};

export const GenericStepperModal = ({ handleClose, onClick, open, steps }) => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const componentRefs = useRef([]);

    const isFirstStep = activeStep === 0;
    const isLastStep = activeStep === steps.length - 1;

    const setComponentRef = (ref) => {
        componentRefs.current[activeStep] = ref;
    };

    const isDisabled = steps.find((e, index) => activeStep === index).disabled;

    const handleNext = (e) => {
        e.preventDefault();
        setActiveStep((prevActiveStep) => {
            if (!isLastStep) return ++prevActiveStep
            else return prevActiveStep
        });
    };

    const handleBack = (e) => {
        e.preventDefault();
        setActiveStep((prevActiveStep) => {
            if (!isFirstStep) return --prevActiveStep
            else return prevActiveStep
        });
    };

    return (
        <ValidatorForm onSubmit={onClick}>
            <Dialog
                maxWidth="lg"
                fullWidth={true}
                open={open}
            >
                <DialogTitle>
                    <div className={classes.root}>
                        <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map(({ step }, index) => (
                                <Step key={index}>
                                    <StepLabel>
                                        <Typography variant='button'>{step}</Typography>
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </div>
                </DialogTitle>
                <Divider />
                <Grid container>
                    <Grid item xs={12} style={{ margin: "1em" }}>
                        {React.cloneElement(steps[activeStep].component(), {
                            ref: setComponentRef,
                        })}
                    </Grid>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "0.5em", margin: "1em" }}>
                        <ButtonGeneric
                            type="button"
                            color='secondary'
                            onClick={isFirstStep ? handleClose : handleBack}
                            text={isFirstStep ? 'Cerrar' : 'Volver'}
                        />
                        <ButtonGeneric
                            type="button"
                            disabled={isDisabled}
                            onClick={isLastStep ? onClick : handleNext}
                            text={isLastStep ? 'Guardar' : 'Siguiente'}
                        />
                    </Grid>
                </Grid>
            </Dialog>
        </ValidatorForm>
    );
};

export const GenericModalForm = ({ open, title, children, handleClose, handleSubmit, textButton = "Guardar", gridStyle, maxWidth = "md" }) => {

    const ModalContent = () => (
        <Grid container>
            <Grid item xs={12} style={{ margin: "1em", ...gridStyle }}>
                {children}
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", gap: "0.5em", margin: "1em" }}>
                <ButtonGeneric
                    type="button"
                    text="Cerrar"
                    color="secondary"
                    onClick={handleClose}
                />
                <ButtonGeneric
                    type="submit"
                    text={textButton}
                />
            </Grid>
        </Grid>
    )

    return (
        <Dialog
            maxWidth={maxWidth}
            fullWidth={true}
            open={open}
        >
            <DialogTitle style={{ display: "flex", justifyContent: "center" }}>
                <Typography variant="button" style={{ fontSize: "1em" }}>
                    {title}
                </Typography>
            </DialogTitle>
            <Divider />
            <ValidatorForm onSubmit={handleSubmit}>
                <ModalContent />
            </ValidatorForm>
        </Dialog>
    );
};

export const GModal = ({ open, title, children, onClose = () => { }, maxWidth = "md", stepper }) => {
    return (
        <Fragment>
            {open && (
                <Dialog
                    maxWidth={maxWidth}
                    fullWidth={true}
                    open={open}
                    onClose={onClose}
                    scroll="body"
                >
                    <DialogContent>
                        {stepper ? (
                            <>
                                {children}
                            </>
                        ) : (
                            <Grid container justify="center">
                                {title && (
                                    <Grid item xs={12} style={{ marginBottom: "0.5em" }}>
                                        <DialogTitle style={{ display: "flex", justifyContent: "center", padding: 0, margin: 0 }}>
                                            <Typography variant="button" style={{ fontSize: "1em" }}>
                                                {title}
                                            </Typography>
                                        </DialogTitle>
                                        <Divider style={{ marginTop: "0.5em" }} />
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    {children}
                                </Grid>
                            </Grid>
                        )}
                    </DialogContent>
                </Dialog>
            )}
        </Fragment>
    );
}